import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/imgs/headshots/jon-hodges.jpg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Photo of Jon Hodges"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "Jon Hodges"),
  /*#__PURE__*/_createElementVNode("h3", null, "CEO | Alphakinetic"),
  /*#__PURE__*/_createElementVNode("p", null, "Jon has worked in financial software development for over 10 years. He initially worked for a consultancy within JP Morgan building large-scale high volume auto-trading systems specialising in FIX protocol and order book management. Later he moved onto the buy-side working with Credit Derivatives (CDO's, CDS) and Fixed Income (Bonds, Repos, ABS, MBS). He has been heavily involved in building valuation frameworks for structured products, working closely with the quantitative analysts. Jon also worked in Beijing to establish and manage offshore development teams.")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_profile = _resolveComponent("profile")!

  return (_openBlock(), _createBlock(_component_profile, null, {
    headshot: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _hoisted_2
    ]),
    _: 1
  }))
}